/* eslint-disable no-control-regex */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { MutableRefObject, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Home.css";
import ring from "../../images/ring_main.png";
import {
  animateLetters,
  animateLettersReverse,
  tweenAnimationSequence,
} from "./helperAnimations";
import {
  GitCompare,
  LogoFacebook,
  LogoGithub,
  LogoGoogle,
  LogoInstagram,
  LogoLinkedin,
  Options,
} from "react-ionicons";
import BgLogo from "../../components/BgLogo";
import TransitionComp from "../../components/TransitionComp";
import anime from "animejs";
import { Link } from "react-router-dom";
import { debounce } from "lodash";
import Navbar from "../../components/Navbar";
import "../../styles/Home.css";
// import AnimationCard from "../components/AnimationCard";
// import { AnimatePresence, motion } from "framer-motion";
// import {Link} from "react-router-dom";
// import BgLogo from "../components/BgLogo";
// import Navbar from "../components/Navbar";
function TopPage() {
  const letterRef = React.useRef() as MutableRefObject<HTMLDivElement>;

  function openInNewTab(url: string) {
    var win = window.open(url, '_blank') as Window;
    win.focus();
  }

  useEffect(() => {
    tweenAnimationSequence();
    const bgMain = (letterRef as MutableRefObject<HTMLDivElement>).current;
    if (typeof bgMain.textContent === "string") {
      // eslint-disable-next-line no-control-regex
      bgMain.innerHTML =
        bgMain.textContent &&
        bgMain.textContent.replace(
          /([^\x00-\x80]|\w)/g,
          "<span class='letter'>$&</span>"
        );
      anime.timeline({ loop: false }).add({
        targets: ".ml7 .letter",
        translateY: ["1.1em", 0],
        translateX: ["0.55em", 0],
        translateZ: 0,
        rotateZ: [180, 0],
        duration: 750,
        easing: "easeOutExpo",
        delay: function (el, i) {
          return 9000 + 60 * i;
        },
      });
    }
  }, []);
  return (
    <>
      <TransitionComp children={<BgLogo />} />

      <div className="home_container">
        <div className="loading-screen"></div>

        <div className="loader">
          <div className="ringOne ring">
            <img src={ring} alt="" />
          </div>

          <div className="ringTwo ring">
            <img src={ring} alt="" />
          </div>
        </div>
      </div>

      {/* HERE */}
      <Navbar />

      {/* <div className="menu">
        <Options
          color={"#6adb9d"}
          height="20px"
          width="20px"
          onClick={() => alert("Hi!")}
          title={"Options"}
        />
      </div> */}

      <div className="header">
        <h1 className="ml7" id="title">
          <span className="text-wrapper">
            <span className="letters" ref={letterRef}>
              FULLSTACK SOFTWARE ENGINEER
            </span>
          </span>
        </h1>

        <p id="tagline" className="p1">
          Over the past 3 years as a software developer, I’ve worked with
          up-and-coming startups and sole clients to successfully help them
          reach their full potential and attract new customers.
        </p>

        <br />

        <p id="tagline" className="p2">
          I believe that getting your projects up and running should not be
          tasking. Let's work together and create some tech solutions.
        </p>

        <div className="buttons">
          <Link to="/about" className="about_btn">
            <button id="one"  style={{cursor: 'pointer'}}>ABOUT</button>
          </Link>
          <Link to="/projects" id="projects_btn">
            <button id="two"  style={{cursor: 'pointer'}}>PROJECTS</button>
          </Link>
        </div>
      </div>

      <div className="bottom-text">MBAJIAKU GEORGE</div>

      <div className="copyright">© 2023. All rights reserved.</div>

      <div className="media">
        <ul>
          <li>
            <LogoGithub
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://github.com/George5555ish")}
              title={"Github"}
              style={{cursor: 'pointer'}}
            />
          </li>
          <li>
            <LogoInstagram
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://www.instagram.com/george_son_/")}
              title={"Instagram"}
              style={{cursor: 'pointer'}}
            />
          </li> 
          <li>
            <LogoLinkedin
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://www.linkedin.com/in/george-mbajiaku-8747b2ab/")}
              title={"LinkedIn"}
              style={{cursor: 'pointer'}}
            />
          </li>
        </ul>
      </div>
    </>
  );
}

export default TopPage;
